import { StationNavigatorBreadcrumb } from '@app/components/base/stations/StationNavigatorBreadcrumb';
import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ComposeIcon } from '@app/modules/compose/components/ComposeIcon';
import { ComposeModule } from '@app/modules/compose/index';
import { useIntl } from 'react-intl';
import { ComposeList } from './ComposeList';

export function ComposeListPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  const title = $t({
    id: 'compose.listScreen.title',
    defaultMessage: 'Compose',
  });

  return (
    <Page htmlTitle={`${title} | ${station.name}`}>
      <Page.Header
        icon={<ComposeIcon />}
        title={[
          title,
          <StationNavigatorBreadcrumb
            key={station.id}
            basePath={ComposeModule.basePath}
            activeId={station.id}
          />,
        ]}
      />
      <ComposeList key={station.id} station={station} />
    </Page>
  );
}
